/** @file placeholderColors: the three colours of a preview placeholder cell (fill, rim, pivot pixel). */
import type { Rgba } from '@zilo/pose3d-image-io/types/image';

/** Mid-grey fill, darker rim, the pivot pixel in the accent orange; the Tile palette leaves these out. */
export const PLACEHOLDER_COLORS: { fill: Rgba; rim: Rgba; pivot: Rgba } = {
  fill: [118, 122, 138, 255],
  rim: [58, 60, 72, 255],
  pivot: [239, 159, 39, 255],
};
